import {mainServer} from '../../variables/config'

export const request_login = async(data) => {
    mainServer.instance.defaults.headers.common['Authorization'] = 'Basic ' + btoa(mainServer.credentials.user + ':' + mainServer.credentials.password);
    let response;
    response = await mainServer.instance.post("/login",data);
    localStorage.setItem('data',JSON.stringify(response.data.data));
}

export const request_recover_password = async(data) => {
    
    mainServer.instance.defaults.headers.common['Authorization'] = 'Basic ' + btoa(mainServer.credentials.user + ':' + mainServer.credentials.password);
    await mainServer.instance.post(`/passwordreset/request`, data)
}

